import React from "react"
import SectionCard from "../../../shared/components/SectionCard"
import { ui } from "../../../shared/styles/uiSystem"

function EmptyState({ loading, text }) {
  return (
    <div style={{ color: "#64748b", fontSize: 13 }}>
      {loading ? "Cargando..." : text}
    </div>
  )
}

function CollapseButton({ collapsed, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        ...ui.secondaryButton,
        minWidth: 42,
        minHeight: 36
      }}
    >
      {collapsed ? "+" : "−"}
    </button>
  )
}

function RankBadge({ rank }) {
  const visual =
    rank === 1
      ? {
          background: "#eff6ff",
          border: "#bfdbfe",
          color: "#1d4ed8",
          label: "#1"
        }
      : rank === 2
        ? {
            background: "#f8fafc",
            border: "#cbd5e1",
            color: "#334155",
            label: "#2"
          }
        : {
            background: "#fff7ed",
            border: "#fdba74",
            color: "#c2410c",
            label: `#${rank}`
          }

  return (
    <div
      style={{
        minWidth: 46,
        height: 46,
        borderRadius: 14,
        display: "grid",
        placeItems: "center",
        background: visual.background,
        border: `1px solid ${visual.border}`,
        color: visual.color,
        fontSize: 14,
        fontWeight: 900
      }}
    >
      {visual.label}
    </div>
  )
}

function DetailTag({ children }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        minHeight: 24,
        padding: "0 8px",
        borderRadius: 999,
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        color: "#334155",
        fontSize: 10.5,
        fontWeight: 800
      }}
    >
      {children}
    </span>
  )
}

function RankRow({ rank, title, detail }) {
  const parts = splitDetail(detail)

  return (
    <div
      style={{
        ...ui.softCard,
        padding: 12,
        borderRadius: 16,
        display: "flex",
        gap: 12,
        alignItems: "flex-start"
      }}
    >
      <RankBadge rank={rank} />

      <div style={{ display: "grid", gap: 8, minWidth: 0, flex: 1 }}>
        <div style={{ display: "grid", gap: 4 }}>
          <div
            style={{
              fontWeight: 900,
              fontSize: 16,
              lineHeight: 1.25,
              color: "#0f172a",
              wordBreak: "break-word"
            }}
          >
            {title}
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#64748b",
              fontWeight: 700
            }}
          >
            Posición {rank}
          </div>
        </div>

        {!!parts.length && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {parts.map((part, index) => (
              <DetailTag key={`${title}-${index}`}>{part}</DetailTag>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default function RankingPanel({
  title,
  subtitle,
  items = [],
  collapsed,
  onToggle,
  loading,
  emptyText
}) {
  const rows = Array.isArray(items) ? items : []

  return (
    <SectionCard
      title={title}
      subtitle={subtitle}
      actions={
        <CollapseButton
          collapsed={collapsed}
          onClick={onToggle}
        />
      }
    >
      {!collapsed && (
        <>
          {!rows.length ? (
            <EmptyState loading={loading} text={emptyText} />
          ) : (
            <div style={{ display: "grid", gap: 10 }}>
              {rows.map((item, index) => (
                <RankRow
                  key={item.key || `${title}-${index}`}
                  rank={index + 1}
                  title={item.title}
                  detail={item.detail}
                />
              ))}
            </div>
          )}
        </>
      )}
    </SectionCard>
  )
}

function splitDetail(detail) {
  return String(detail || "")
    .split("·")
    .map((item) => item.trim())
    .filter(Boolean)
}